import React from 'react';
import {Store} from '../../models/store.model';
import {AppText, AppCardTitle, AppLabelText, AppSectionTitle} from '../../../../Presentation/components/ui/Typography';
import {Clock, Calendar} from 'lucide-react';

interface StoreLastVisitInfoProps {
  store: Store;
}

export const StoreLastVisitInfo: React.FC<StoreLastVisitInfoProps> = ({store}) => {
  const formatDate = (dateString: string | null | undefined) => {
    if (!dateString) {return 'لا يوجد';}

    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className="space-y-4">
      <AppCardTitle className="border-b pb-2">آخر زيارة ودفع</AppCardTitle>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-gradient-to-br from-slate-50 to-slate-100 p-4 rounded-lg border border-slate-200">
          <div className="flex items-center gap-3 mb-2">
            <Clock className="w-5 h-5 text-slate-600" />
            <AppLabelText className="text-slate-700 font-medium">تاريخ آخر زيارة</AppLabelText>
          </div>
          <AppSectionTitle className="font-bold text-slate-900">
            {formatDate(store.lastVisit)}
          </AppSectionTitle>
        </div>

        <div className="bg-gradient-to-br from-green-50 to-green-100 p-4 rounded-lg border border-green-200">
          <div className="flex items-center gap-3 mb-2">
            <Calendar className="w-5 h-5 text-green-600" />
            <AppLabelText className="text-green-700 font-medium">تاريخ آخر دفع</AppLabelText>
          </div>
          <AppSectionTitle className="font-bold text-green-900">
            {formatDate(store.lastPaymentDate)}
          </AppSectionTitle>
        </div>
      </div>
    </div>
  );
};


